module.exports = __webpack_public_path__ + "img/s13.893d96eb.png";